import { Stack } from '@rossum/ui/material';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router';
import { isTrialSelector } from '../../redux/modules/organization/selectors';
import {
  hasSubscriptionPlanExistSelector,
  resolvedFeaturesSelector,
} from '../pricing/selectors';
import { HistoryPage as History } from './History';
import { useBillingEnabled } from './hooks/useBillingEnabled';
import { useBillingEntity } from './hooks/useBillingEntity';
import { MyPlan } from './MyPlan';
import { Overview } from './Overview';
import { Usage } from './Usage';

const BILLING_ROUTE = '/billing';

const Billing = () => {
  const isPricingActive = useSelector(hasSubscriptionPlanExistSelector);
  const isTrial = useSelector(isTrialSelector);
  const { isEnabled, isInitialLoading } = useBillingEnabled();

  const billingEntity = useBillingEntity();
  const resolvedFeatures = useSelector(resolvedFeaturesSelector);

  if (isInitialLoading) {
    return null;
  }

  return isEnabled && billingEntity ? (
    <Stack data-page-title="billing" sx={{ overflow: 'hidden', height: 1 }}>
      <Route exact path={`${BILLING_ROUTE}/my-plan`}>
        {resolvedFeatures && isPricingActive ? (
          <MyPlan subscriptionUsage={resolvedFeatures} />
        ) : null}
      </Route>
      <Route exact path={`${BILLING_ROUTE}/overview`}>
        <Overview billingEntity={billingEntity} />
      </Route>
      <Route exact path={`${BILLING_ROUTE}/statistics`}>
        <Usage billingEntity={billingEntity} />
      </Route>
      <Route exact path={`${BILLING_ROUTE}/history`}>
        {!isTrial && <History billingEntity={billingEntity} />}
      </Route>
    </Stack>
  ) : (
    <Redirect to="/annotations" />
  );
};

export { Billing };
